import React from 'react';
import { COOLDOWN_UNITS, COOLDOWN_UNIT_LABELS } from '../../../utils/ruleCooldown';
import { UNKNOWN_UNIT_LABEL } from './RecurrenceFields';

/**
 * Пауза правила после срабатывания (cooldown, ТЗ №42). Входит в core-правило:
 * включена — cooldown_value + cooldown_unit, выключена — оба null.
 * Состояние формы — { enabled, value, unit } из utils/ruleCooldown.
 */
const CooldownFields = ({ value, onChange, error = '', disabled = false, idPrefix = 'vio' }) => {
  const enabled = Boolean(value?.enabled);
  const unitKnown = COOLDOWN_UNITS.includes(value?.unit);

  return (
    <fieldset className="vio-rule-extra">
      <div className="form-check form-switch vio-switch">
        <input
          id={`${idPrefix}-cooldown-enabled`}
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={enabled}
          disabled={disabled}
          onChange={(event) => onChange({ ...value, enabled: event.target.checked })}
        />
        <label className="form-check-label vio-switch-label" htmlFor={`${idPrefix}-cooldown-enabled`}>
          Пауза
        </label>
      </div>

      {enabled && (
        <div className="vio-rule-extra-fields">
          <div className="vio-field">
            <label className="vio-field-label" htmlFor={`${idPrefix}-cooldown-value`}>
              Пауза после срабатывания
            </label>
            <div className="vio-cooldown-inputs">
              <input
                id={`${idPrefix}-cooldown-value`}
                type="number"
                min="1"
                step="1"
                value={value.value}
                disabled={disabled}
                onChange={(event) => onChange({ ...value, value: event.target.value })}
              />
              <select
                aria-label="Единица паузы"
                value={value.unit}
                disabled={disabled}
                onChange={(event) => onChange({ ...value, unit: event.target.value })}
              >
                {!unitKnown && <option value={value.unit} disabled>{UNKNOWN_UNIT_LABEL}</option>}
                {COOLDOWN_UNITS.map((unit) => (
                  <option key={unit} value={unit}>{COOLDOWN_UNIT_LABELS[unit]}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
      {error && <p className="vio-field-error">{error}</p>}
    </fieldset>
  );
};

export default CooldownFields;
